import fetch from '../../utils/fetch';
import { getUserToken } from '../../utils/helpers';
import { API_ROUTES } from '../../utils/constants';

export const createAdminAPI = (data) => {
  const accessToken = getUserToken().access_token;
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`,
  };
  return fetch({
    method: 'POST', route: API_ROUTES.REGISTRATION_ADMIN, requestHeaders: headers, data, basic: false,
  });
};

export default {
  createAdminAPI,
};



// WEBPACK FOOTER //
// ./src/reducers/create-admin/api.js